import { render, staticRenderFns } from "./wsAccordionVariant.vue?vue&type=template&id=541fd081&scoped=true&"
import script from "./wsAccordionVariant.vue?vue&type=script&lang=js&"
export * from "./wsAccordionVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541fd081",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VExpandTransition,VIcon})
